import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ExternalVideoAttributes, ExternalVideoEditorIds, InternalVideoAttributes, InternalVideoEditorIds, PlainVideoComponent, VIDEO_COMPONENT_NAME } from '../plain-video/plain-video.component';
import { FigureComponent } from '@knorr-bremse-portals/ngx-components/components/figure';
import { InnerSectionComponent } from '../inner-section/inner-section.component';
import { EditorIdDirective } from '../../directives/editor-id.directive';
import { InnerSection } from '../../types/section';
import { CaptionAttributes, CaptionEditorIds } from '../../types/figure';

export type InternalVideoFigureSection = InnerSection<
  InternalVideoAttributes & CaptionAttributes,
  InternalVideoEditorIds | CaptionEditorIds,
  typeof VIDEO_COMPONENT_NAME
>;

export type ExternalVideoFigureSection = InnerSection<
  ExternalVideoAttributes & CaptionAttributes,
  ExternalVideoEditorIds | CaptionEditorIds,
  typeof VIDEO_COMPONENT_NAME
>;

export type VideoFigureSection = InternalVideoFigureSection | ExternalVideoFigureSection;

@Component({
    selector: 'app-video-figure',
    styleUrls: ['./video-figure.component.scss'],
    templateUrl: './video-figure.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PlainVideoComponent,
        FigureComponent,
        EditorIdDirective,
    ],
})
export class VideoFigureComponent extends InnerSectionComponent<VideoFigureSection> {}
